import script from "./GlobalAppointmentOffcanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAppointmentOffcanvas.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAppointmentOffcanvas.vue?vue&type=style&index=0&id=be474e90&lang=css"

const __exports__ = script;

export default __exports__